// @ts-nocheck
import { Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import styled from 'styled-components';

import PageLayout from '../../layout/PageLayout';

const PageTitle = styled(Typography)`
  padding-bottom: ${(props) => props.theme.spacing(2)}px;
`;

const SectionTitle = styled(Typography)`
  padding: ${(props) => props.theme.spacing(1, 0, 0.5, 0)};
`;

const StyledPaper = styled(Paper)`
  margin: ${(props) => props.theme.spacing(4)} auto;
`;

const HeaderCell = styled(TableCell)`
  background-color: ${(props) => props.theme.palette.grey[200]};
  font-weight: 600;
  padding: ${(props) => props.theme.spacing(1, 2)};
  border-bottom: 2px solid ${(props) => props.theme.palette.divider};
`;

const BodyCell = styled(TableCell)`
  padding: ${(props) => props.theme.spacing(1, 2)};
  border-top: 1px solid ${(props) => props.theme.palette.divider};
`;

function CookiePolicyEN() {
  return (
    <PageLayout>
      <PageTitle variant="h1" color="primary">
        Mer Germany – Cookie Policy GROA Customer Portal (groa.mer.eco)
      </PageTitle>

      <Typography variant="body1" align="center" paragraph>
        (as of November 2025)
      </Typography>

      <SectionTitle variant="h3">1. Introduction</SectionTitle>

      <Typography variant="body1" paragraph>
        Our online customer portal <a href="https://groa.mer.eco">https://groa.mer.eco</a> (hereinafter:
        &quot;GROA&quot; or &quot;customer portal&quot;) uses cookies and technologies with similar functionality.
        Below, we, Mer Germany GmbH (hereinafter &quot;Mer,&quot; &quot;us,&quot; &quot;we&quot;), provide you with
        information about the use of such cookies and similar technologies on the customer portal.
      </Typography>

      <SectionTitle variant="h3">2. What are cookies and similar technologies?</SectionTitle>

      <Typography variant="body1" paragraph>
        Cookies are text files that are stored on your device by a web server. These cookies enable information to be
        stored on your device and accessed.
      </Typography>
      <Typography variant="body1" paragraph>
        A distinction can be made between cookies that are deleted immediately after the end of the usage process
        (so-called &quot;session cookies&quot;) and cookies that remain on your device for a certain period of time
        (so-called &quot;persistent cookies&quot;).
      </Typography>
      <Typography variant="body1" paragraph>
        A further distinction is made between first-party cookies and third-party cookies. First-party cookies are
        managed and read directly by us. Third-party cookies, on the other hand, are controlled and managed by a
        third-party provider.
      </Typography>
      <Typography variant="body1" paragraph>
        In addition to cookies, we also use comparable technologies that also store and/or read information in your
        browser or device, using locally shared objects or local storage. These include, for example, web beacons and
        tracking pixels. These are electronic graphic images embedded in a website to collect information about your
        visit to a website (e.g., type of device and browser used, IP address, website visits, clicks on certain links
        or objects).
      </Typography>
      <Typography variant="body1" paragraph>
        With the help of such cookies and similar technologies, you as a visitor to the customer portal can be uniquely
        identified. This makes it possible to recognize you the next time you visit our website.
      </Typography>
      <Typography variant="body1" paragraph>
        In the following, we use the term &quot;cookies&quot; holistically with regard to cookies and similar
        technologies.
      </Typography>

      <SectionTitle variant="h3">3. Which cookies do we use?</SectionTitle>
      <SectionTitle variant="h3">3.1. Strictly necessary cookies </SectionTitle>

      <Typography variant="body1" paragraph>
        These cookies ensure that certain services on the website that are essential for its use function properly.
        Since the use of these cookies is mandatory for the use of the website, these cookies are always activated
        regardless of consent.
      </Typography>
      <Typography variant="body1" paragraph>
        We currently use the following strictly necessary cookies:
      </Typography>
      <StyledPaper elevation={2}>
        <Table align="center">
          <TableHead>
            <TableRow>
              <HeaderCell>Cookie name</HeaderCell>
              <HeaderCell>Function</HeaderCell>
              <HeaderCell>Provider / Domain</HeaderCell>
              <HeaderCell>Storage period</HeaderCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <BodyCell>cookieConsent</BodyCell>
              <BodyCell>
                Cookie for storing user preferences for the purpose of confirming the use of cookies that require
                consent.
              </BodyCell>
              <BodyCell>Mer</BodyCell>
              <BodyCell>1 year</BodyCell>
            </TableRow>
            <TableRow>
              <BodyCell>_legacy_auth0.is.authenticated</BodyCell>
              <BodyCell>Authentication</BodyCell>
              <BodyCell>Auth0</BodyCell>
              <BodyCell>7 days</BodyCell>
            </TableRow>
            <TableRow>
              <BodyCell>auth0.is.authenticated</BodyCell>
              <BodyCell>Authentication</BodyCell>
              <BodyCell>Auth0</BodyCell>
              <BodyCell>7 days</BodyCell>
            </TableRow>
          </TableBody>
        </Table>
      </StyledPaper>

      <SectionTitle variant="h3">3.2. Analysis cookies</SectionTitle>

      <Typography variant="body1" paragraph>
        These cookies help us to record your usage behavior on our website and your personal preferences. We use this
        information to tailor our website to your interests. These cookies are only used with your consent and can be
        deactivated at any time.
      </Typography>
      <Typography variant="body1" paragraph>
        We currently use the following analysis cookies:
      </Typography>
      <StyledPaper elevation={2}>
        <Table align="center">
          <TableHead>
            <TableRow>
              <HeaderCell>Cookie name</HeaderCell>
              <HeaderCell>Function</HeaderCell>
              <HeaderCell>Provider / Domain</HeaderCell>
              <HeaderCell>Storage period</HeaderCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <BodyCell>_ga</BodyCell>
              <BodyCell>Collect data and your website usage statistics</BodyCell>
              <BodyCell>Google Analytics</BodyCell>
              <BodyCell>2 years</BodyCell>
            </TableRow>
            <TableRow>
              <BodyCell>_gcl_au</BodyCell>
              <BodyCell>Collect data and your website usage statistics</BodyCell>
              <BodyCell>Google Analytics</BodyCell>
              <BodyCell>90 days</BodyCell>
            </TableRow>
            <TableRow>
              <BodyCell>_uetvid</BodyCell>
              <BodyCell>Collect data and your website usage statistics</BodyCell>
              <BodyCell>Microsoft</BodyCell>
              <BodyCell>90 days</BodyCell>
            </TableRow>
            <TableRow>
              <BodyCell>sbjs_current</BodyCell>
              <BodyCell>Collect data and your website usage statistics</BodyCell>
              <BodyCell>Sourcebuster</BodyCell>
              <BodyCell>Session duration</BodyCell>
            </TableRow>
            <TableRow>
              <BodyCell>sbjs_current_add</BodyCell>
              <BodyCell>Collect data and your website usage statistics</BodyCell>
              <BodyCell>Sourcebuster</BodyCell>
              <BodyCell>Session duration</BodyCell>
            </TableRow>
            <TableRow>
              <BodyCell>sbjs_first</BodyCell>
              <BodyCell>Collect data and your website usage statistics</BodyCell>
              <BodyCell>Sourcebuster</BodyCell>
              <BodyCell>Session duration</BodyCell>
            </TableRow>
            <TableRow>
              <BodyCell>sbjs_first_add</BodyCell>
              <BodyCell>Collect data and your website usage statistics</BodyCell>
              <BodyCell>Sourcebuster</BodyCell>
              <BodyCell>Session duration</BodyCell>
            </TableRow>
            <TableRow>
              <BodyCell>sbjs_migrations</BodyCell>
              <BodyCell>Collect data and your website usage statistics</BodyCell>
              <BodyCell>Sourcebuster</BodyCell>
              <BodyCell>Session duration</BodyCell>
            </TableRow>
            <TableRow>
              <BodyCell>sbjs_udata</BodyCell>
              <BodyCell>Collect data and your website usage statistics</BodyCell>
              <BodyCell>Sourcebuster</BodyCell>
              <BodyCell>Session duration</BodyCell>
            </TableRow>
          </TableBody>
        </Table>
      </StyledPaper>

      <SectionTitle variant="h3">4. Activating/deactivating and deleting cookies</SectionTitle>

      <Typography variant="body1" paragraph>
        You can block the use of cookies in all common browsers by adjusting the settings in your browser. You can
        delete cookies that have already been set. For more information, please refer to the help function of all common
        browsers.
      </Typography>
      <Typography variant="body1" paragraph>
        Please note that you may not be able to block all technologies that store information on your device or access
        information stored there via your browser settings.
      </Typography>
      <Typography variant="body1" paragraph>
        Please note that the website may not function properly if all cookies are disabled. If you delete cookies in
        your browser, they will be placed again when you visit our website again.
      </Typography>

      <SectionTitle variant="h3">5. Contact details</SectionTitle>

      <Typography variant="body1" paragraph>
        If you have any questions and/or comments about our cookie policy, you can contact us using the contact details
        provided in section 1 of our privacy policy for the customer portal.
      </Typography>
    </PageLayout>
  );
}

export default CookiePolicyEN;
